import $ from 'jquery';

function initEntryWinners(el) {
    const $el = $(el);
    const endpointArgs = $el.data("endpoint-args");

    $('.js-filter-label').on('click', function() {
        const $this = $(this);
        if( $this.hasClass('entry-winners__filter-label--active')) {
            $this.next('.entry-winners__filter-options').slideUp('fast', function() {
                $this.removeClass('entry-winners__filter-label--active');
            });
        } else {
            $this.next('.entry-winners__filter-options').slideDown('fast')
            $this.addClass('entry-winners__filter-label--active');
        }
    });

    $('.js-filter-winner').on('click', function() {
        $(this).siblings().removeClass('entry-winners__filter-option--active');
        $(this).addClass('entry-winners__filter-option--active');

        const defaultYear = $('.js-year').data('default-year');
        const year = $('.js-year .entry-winners__filter-option--active').data('year');
        let term = $('.js-term .entry-winners__filter-option--active').data('term');

        const urlSearchParams = new URLSearchParams(window.location.search);
        const params = Object.fromEntries(urlSearchParams.entries());

        if($('.js-filter-label').hasClass('entry-winners__filter-label--active')) {
            $('.js-filter-label').next('.entry-winners__filter-options').slideUp(function() {
                $('.js-filter-label').removeClass('entry-winners__filter-label--active');
            });
        }

        if($('.entry-winners__filter-option').hasClass('entry-winners__filter-option--'+params.cat)) {
            term = $('.entry-winners__filter-option--'+params.cat).data('term');
            $('.entry-winners__filter-option--'+params.cat).addClass('entry-winners__filter-option--active');
            $('.entry-winners__filter-option').removeClass('entry-winners__filter-option--'+params.cat);
        }

        term = term ? term.split(',') : [];

        $.ajax({
            type: 'POST',
            url: '/wp/wp-admin/admin-ajax.php',
            dataType: 'html',
            data: {
                action: 'filter_winners',
                defaultYear: defaultYear,
                year: year,
                term: term[1],
                ...endpointArgs,
            },
            success: function(res) {
                $('#js-entry-winners').html(res);
                $('.js-year .js-filter-label').html(year);
                $('.js-term .js-filter-label').html(term[0]);
                $('.entry-winners__filter-options').hide();
            },
        });
    });
}

export default initEntryWinners;
